<template>
    <div>
        <v-menu
            v-model="dateMenu"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
            <template #activator="{ on }">
                <v-btn
                    v-on="on"
                    color="primary"
                    outlined
                >
                    <v-icon left>mdi-calendar</v-icon>
                    {{ displayedDate }}
                </v-btn>
            </template>

            <v-date-picker
                v-model="date"
                no-title
                scrollable
                locale="id-ID"
                color="primary"
            ></v-date-picker>
        </v-menu>

        <v-menu
            v-model="timeMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
            <template #activator="{ on }">
                <v-btn
                    v-on="on"
                    color="primary"
                    outlined
                    class="ml-2"
                >
                    <v-icon left>mdi-clock</v-icon>
                    {{ displayedTime }}
                </v-btn>
            </template>

            <v-time-picker
                v-model="time"
                format="24hr"
                header-color="primary"
                @click:minute="timeMenu = false"
            ></v-time-picker>
        </v-menu>
    </div>
</template>

<script>
import moment from '@/plugins/moment'

export default {
    data: () => ({
        dateMenu: false,
        date: null,
        timeMenu: false,
        time: null,
    }),

    computed: {
        displayedDate() {
            if (!this.date) {
                return 'Tanggal'
            }

            return moment(this.date).formatDay()
        },
        displayedTime() {
            if (!this.time) {
                return 'Jam'
            }

            return `${moment(this.time, 'HH:mm').formatTime()}`
        },
    },

    watch: {
        date() {
            this.emitDateTime()
        },
        time() {
            this.emitDateTime()
        },
    },

    methods: {
        emitDateTime() {
            if (this.date && this.time) {
                this.$emit(
                    'input',
                    moment(
                        `${this.date} ${this.time}`,
                        'YYYY-MM-DD HH:mm'
                    ).format()
                )
            }
        },
    },
}
</script>
